/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { WarehouseEMEADetailsModal } from './WarehouseEMEADetailsModel';
import UpdateIcon from '@mui/icons-material/Update';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { Warehouse } from './common.types';
import WarehouseStockOverMouse from './WarehouseStockOverMouse';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { OutOfStock } from './OutOfStock';

type Props = {
  ShowCentralStockTtypeSku: boolean;
  'data-testid'?: string;
  fromPage: string;
  licenseSelectorVendorSubrange?: string;
  onclick?: ((sku: string) => void) | undefined;
  productType?: string;
  reserveFlag: boolean;
  showWarehousePopupflag: boolean;
  siteCode: string;
  sku: string;
  skuType?: string;
  stockStatus: any;
  totalAvailableStock: number;
  vendorCode?: string;
  warehouseStockDetail: any;
  warehouses?: Warehouse[];
};

export function WarehouseEMEAComponent(props: Props) {
  const {
    ShowCentralStockTtypeSku,
    fromPage,
    licenseSelectorVendorSubrange,
    onclick,
    productType,
    reserveFlag,
    showWarehousePopupflag,
    sku,
    skuType,
    totalAvailableStock,
    vendorCode,
    warehouseStockDetail,
    warehouses,
  } = props;

  const [showWarehouseDetails, setShowWarehouseDetails] = useState(
    showWarehousePopupflag
  );

  function getNumV1(val: any) {
    if (isNaN(val)) {
      return 0;
    }
    return val;
  }

  const [warehouseStockDetailUpdate] = useState(warehouseStockDetail);
  const { 'data-testid': testid = 'required' } = props;
  // eslint-disable-next-line import/no-named-as-default-member
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const [displayBothFlag, setDisplayBothFlag] = useState(false);
  const [displayCentralFlag, setDisplayCentralFlag] = useState(false);
  const [displayLocalFlag, setDisplayLocalFlag] = useState(false);
  const [displayOutOfStockFlag, setDisplayOutOfStockFlag] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(true);

  const onOrder =
    props.warehouses !== null &&
    props.warehouses !== undefined &&
    props.warehouses.reduce(
      (acc, cur) =>
        cur.location?.toUpperCase() === 'LOCAL' ||
        cur.location?.toUpperCase() === 'CENTRAL'
          ? acc + cur.onOrder
          : acc,
      0
    );

  const localStock =
    props.warehouses !== null &&
    props.warehouses !== undefined &&
    props.warehouses.reduce(
      (acc, cur) =>
        cur.location?.toUpperCase() === 'LOCAL' ? acc + cur.stock : acc,
      0
    );

  const centralStockIsAvailable =
    props.warehouses != null &&
    props.warehouses.find((ws) =>
      ws.location?.toUpperCase().includes('CENTRAL')
    );

  const centralStock =
    props.warehouses !== null &&
    props.warehouses !== undefined &&
    props.warehouses.reduce(
      (acc, cur) =>
        cur.location?.toUpperCase() === 'CENTRAL' ? acc + cur.stock : acc,
      0
    );

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      if (
        (getNumV1(localStock) > 0 && getNumV1(centralStock) > 0) ||
        (centralStockIsAvailable &&
          centralStockIsAvailable !== undefined &&
          productType === 'T' &&
          totalAvailableStock > 0)
      )
        setDisplayBothFlag(true);
      else if (getNumV1(localStock) > 0) setDisplayLocalFlag(true);
      else if (getNumV1(centralStock) > 0) setDisplayCentralFlag(true);
      if (getNumV1(localStock) <= 0 && getNumV1(centralStock) <= 0)
        setDisplayOutOfStockFlag(true);
      if (
        getNumV1(centralStock) > 0 &&
        getNumV1(localStock) <= 0 &&
        (productType === null || productType === '') &&
        ShowCentralStockTtypeSku
      ) {
        setDisplayOutOfStockFlag(true);
        setDisplayCentralFlag(false);
      }
    }
  }, [
    centralStock,
    centralStockIsAvailable,
    isInitialRender,
    localStock,
    onOrder,
    productType,
    totalAvailableStock,
    ShowCentralStockTtypeSku,
  ]);

  return (
    <>
      <Typography
        bgcolor={
          getNumV1(localStock) > 0 || getNumV1(centralStock) > 0
            ? [
                getNumV1(centralStock) > 0 &&
                getNumV1(localStock) <= 0 &&
                (productType === null || productType === '') &&
                ShowCentralStockTtypeSku
                  ? '#FEF3F2'
                  : '#E3FFFA',
              ]
            : '#FEF3F2'
        }
        component="span"
        p={1}
        sx={{
          borderRadius: '20px',
          fontWeight: 'bold',
        }}
        variant="body2"
      >
        <StyledButton
          data-testid={`${testid}-WarehouseEMEAStock`}
          onClick={() => {
            onclick && onclick(sku);
            setShowWarehouseDetails(true);
          }}
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
          size="small"
          sx={{
            color:
              getNumV1(localStock) <= 0 && getNumV1(centralStock) <= 0
                ? '#B11616'
                : [
                    getNumV1(centralStock) > 0 &&
                    getNumV1(localStock) <= 0 &&
                    (productType === null || productType === '') &&
                    ShowCentralStockTtypeSku
                      ? '#B11616'
                      : '#18846F',
                  ],
            cursor:
              getNumV1(localStock) > 0 ||
              getNumV1(centralStock) > 0 ||
              getNumV1(onOrder) > 0
                ? 'pointer'
                : 'initial',
            fontSize: '0.87rem',
            fontWeight: '600',
            lineHeight: '19px',
            padding: '0px',
            textTransform: 'none',
          }}
          variant="text"
        >
          <Stack
            alignItems="center"
            direction="row"
            divider={
              props.reserveFlag && (
                <Divider
                  flexItem
                  orientation="vertical"
                  sx={{
                    borderLeftWidth: '0px',
                    borderRightWidth: '1px',
                    color: '#18846F',
                    margin: '0px',
                  }}
                />
              )
            }
            justifyContent="center"
            sx={{
              '.MuiDivider-root': { borderColor: '#ccc' },
              display: 'flex',
              fontSize: '16px',
              lineHeight: '18px',
            }}
          >
            <Box sx={{ display: 'flex' }}>
              {displayBothFlag &&
                ShowCentralStockTtypeSku &&
                (productType === null || productType === '') && (
                  <IconContainer component="p">
                    <LocationOnOutlinedIcon></LocationOnOutlinedIcon>
                    {localStock}
                  </IconContainer>
                )}

              {displayBothFlag &&
                ShowCentralStockTtypeSku &&
                productType !== null &&
                (productType?.toUpperCase() === 'T' ||
                  productType?.toUpperCase() === 'W') && (
                  <IconContainer component="p">
                    <UpdateIcon></UpdateIcon>
                    {centralStock}
                  </IconContainer>
                )}

              {displayBothFlag && !ShowCentralStockTtypeSku && (
                <>
                  <IconContainer component="p">
                    <LocationOnOutlinedIcon></LocationOnOutlinedIcon>
                    {localStock}
                  </IconContainer>
                  <IconContainer component="p">
                    <UpdateIcon></UpdateIcon>
                    {centralStock}
                  </IconContainer>
                </>
              )}

              {displayLocalFlag && (
                <>
                  <IconContainer component="p">
                    <LocationOnOutlinedIcon></LocationOnOutlinedIcon>
                    {localStock}
                  </IconContainer>
                </>
              )}
              {displayCentralFlag && (
                <>
                  <IconContainer component="p">
                    <UpdateIcon></UpdateIcon>
                    {centralStock}
                  </IconContainer>
                </>
              )}
            </Box>

            {(getNumV1(localStock) > 0 || getNumV1(centralStock) > 0) &&
              props.reserveFlag === true && (
                <div style={{ marginLeft: '0.50rem' }}>
                  <ReservedIcon component="span">R</ReservedIcon>
                </div>
              )}
          </Stack>
          {displayOutOfStockFlag && (
            <OutOfStock
              ShowCentralStockTtypeSkuV2={ShowCentralStockTtypeSku}
              centralStock={centralStock}
              localStock={localStock}
              productType={productType}
              reserveFlag={props.reserveFlag}
              warehouses={warehouses}
            ></OutOfStock>
          )}
          <Popover
            PaperProps={{
              style: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
              },
            }}
            anchorEl={anchorEl}
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'bottom',
            }}
            disableRestoreFocus
            id="mouse-over-popover"
            onClose={handlePopoverClose}
            open={open}
            sx={{
              borderRadius: '6px',
              pointerEvents: 'none',
            }}
            transformOrigin={{
              horizontal: 'left',
              vertical: 'top',
            }}
          >
            {anchorEl !== null ? (
              <WarehouseStockOverMouse
                ShowCentralStockTtypeSku={ShowCentralStockTtypeSku}
                centralStock={centralStock ? centralStock : 0}
                displayBothFlag={displayBothFlag}
                displayCentralFlag={displayCentralFlag}
                displayLocalFlag={displayLocalFlag}
                displayOutOfStockFlag={displayOutOfStockFlag}
                localStock={localStock ? localStock : 0}
                onOrder={onOrder ? onOrder : 0}
                productType={productType}
              ></WarehouseStockOverMouse>
            ) : (
              ' '
            )}
          </Popover>
        </StyledButton>

        {showWarehouseDetails && (
          <WarehouseEMEADetailsModal
            ShowCentralStockTtypeSku={ShowCentralStockTtypeSku}
            fromPage={fromPage}
            id={testid}
            licenseSelectorVendorSubrange={licenseSelectorVendorSubrange}
            onClose={() => setShowWarehouseDetails(false)}
            open={showWarehouseDetails}
            productType={productType}
            reserveFlag={reserveFlag}
            sku={sku}
            skuType={skuType}
            vendorCode={vendorCode}
            warehouseDetails={warehouseStockDetailUpdate ?? []}
            warehouses={warehouses}
          />
        )}
      </Typography>
    </>
  );
}

const StyledButton = styled(Button)({
  '&.MuiButton-root:focus': {
    outline: 'none',
  },
  '&.MuiButton-root:hover': {
    background: 'none',
  },
  '&.MuiButtonBase-root, &.MuiButton-root': {
    height: '26px',
    textTransform: 'none',
  },
});

const ReservedIcon = styled(Box)(() => ({
  alignItems: 'center',
  border: '3px solid #18846F',
  borderRadius: '10%',
  color: '#18846F',
  display: 'inline-flex',
  height: 22,
  justifyContent: 'center',
  width: 20,
}));
const IconContainer = styled(Box)(() => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  marginRight: '10px',
}));
